export const userRole = ['user', 'admin']

export enum UserRole { 
  ADMIN = 'admin',
  USER = 'user'
}

export const mappedRole = {
  [UserRole.ADMIN]: 'Admin',
  [UserRole.USER]: 'User'
}
